import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['buttonsContainer', 'notLegalAgeMessage'];

  replaceButtonsWithMessage (event){
    this.buttonsContainerTarget.style.display = 'none';
    this.notLegalAgeMessageTarget.style.display = 'block';
  }
}